import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=134db7d0&scoped=true&"
import script from "./InputFile.vue?vue&type=script&lang=ts&"
export * from "./InputFile.vue?vue&type=script&lang=ts&"
import style0 from "./InputFile.vue?vue&type=style&index=0&id=134db7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134db7d0",
  null
  
)

export default component.exports